import React, { Component } from 'react';
import StoreManager from '../appdata';

class StepBar extends Component {
  render() {
    const appState = StoreManager.appdata?.thisApp?.state;

    if(appState == null || appState == undefined){
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '1rem',
          }}
        >
        </div>
      );
    }

    const indexStep = appState?.indexStep ?? 0; // fallback về 0 nếu undefined

    const numberOfSteps = StoreManager.appdata?.configEkyc?.stepVerification?.length ?? 0;
    const stepBarColor = StoreManager.appdata?.configEkyc?.stepBarColor ?? '#000';
    const stepBarBackgroundColor = StoreManager.appdata?.configEkyc?.stepBarBackgroundColor ?? '#ccc';

    console.log("currentStep", indexStep, numberOfSteps);

    const steps = [];
    for (let i = 0; i < numberOfSteps; i++) {
      steps.push(
        <div
          key={i}
          style={{
            width: 50,
            height: 4,
            backgroundColor: i <= indexStep ? stepBarColor : stepBarBackgroundColor,
            marginRight: 5,
          }}
        ></div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '1rem',
        }}
      >
        {steps}
      </div>
    );
  }
}


export default StepBar;